import debugTools from "./debug";

class ConfigManager {
    constructor() {
        this.config = {};
        this.tracking = {
            targets: new Set(),
            experiments: new Set(),
            sources: {},
        };
        this.reserveKeys = new Set();
    }

    // these functions should be called in order of most to least priority

    addTargetConfig(config, targetId, currentTargetState) {
        const configKeys = Object.keys(config);
        const overlapKeys = configKeys.filter((key) => this.reserveKeys.has(key));

        if (!overlapKeys.length) {
            Object.assign(this.config, config);
            configKeys.forEach((key) => {
                this.reserveKeys.add(key);
                this.tracking.sources[key] = {
                    targetId,
                    experimentId: null,
                    bucketId: null,
                    assignedDate: currentTargetState?.assignedDate ?? new Date(),
                    assignedEndDate: null,
                };
            });
            this.tracking.targets.add(targetId);

            return true;
        }

        debugTools.debug(`Tried to add target config for ${ targetId } but some keys already existed`,
            {
                targetConfig: config,
                overlapKeys,
            }
        );

        return false;
    }

    addExperimentConfig(config, trackingStr, endTime, currentExperimentState) {
        const reserveKeys = Object.keys(config);

        const targetId = trackingStr.split(".")[0];
        const experimentId = trackingStr.split(".")[1].split("=")[0];
        const bucketId = trackingStr.split("=")[1];

        const overlapKeys = reserveKeys
            .filter((key) => this.reserveKeys.has(key));

        if (!overlapKeys.length) {
            Object.assign(this.config, config);
            reserveKeys.forEach((key) => {
                this.reserveKeys.add(key);
            });
            reserveKeys.forEach((key) => {
                this.tracking.sources[key] = {
                    targetId,
                    experimentId,
                    bucketId,
                    assignedDate: currentExperimentState?.assignedDate ?? new Date(),
                    assignedEndDate: endTime,
                };
            });
            this.tracking.targets.add(targetId);
            this.tracking.experiments.add(trackingStr);

            return true;
        }

        debugTools.debug(
            `Tried to add experiment config for targetId ${ targetId },
             experimentId ${ experimentId } bucketId ${ bucketId } but some keys already existed`,
            {
                experimentConfig: config,
                overlapKeys,
            }
        );

        return false;
    }

    getConfig() {
        return {
            ...this.config,
            ...this.formatTracking(),
        };
    }

    formatTracking() {
        return {
            tracking: {
                targets: Array.from(this.tracking.targets).join(","),
                experiment: Array.from(this.tracking.experiments).join(","),
                sources: this.tracking.sources,
            },
        };
    }
}

export default ConfigManager;
